import { getStaOperatorHamaliLabel, isStaCompany } from '../../common/helper'
import { GT_COMPANY_ID, URVASHI_TRAVELS } from '../../../helper/companyIdhardcode'
import { accessNameV2 } from '../BrnchUsrMaster/constants'

const au = (translations) => translations?.adminUpdate || {}

export const MODIFY_USE_BOOKING_PRICE_FLAGS_COMPANIES = [URVASHI_TRAVELS]

export const shouldUseBookingPriceFlagsOnModify = (companyId) =>
  MODIFY_USE_BOOKING_PRICE_FLAGS_COMPANIES.includes(Number(companyId))

export const getSearchByOptions = (translations) => {
  const t = au(translations)
  return [
    { id: 1, name: t.lrNumber || 'LR Number' },
    { id: 2, name: t.manualLrNumber || 'Manual LR Number' },
    { id: 3, name: t.challanNumber || 'Challan Number' },
    { id: 4, name: t.senderMobileNumber || 'Sender Mobile Number' },
    { id: 5, name: t.receiverMobileNumber || 'Receiver Mobile Number' },
  ]
}

export const getSenderReceiverDetailsUpdate = (translations) => ({
  id: 1,
  name: au(translations).senderReceiverDetailsUpdate || 'Sender Receiver Details Update',
})

export const getEwayBillUpdate = (translations) => ({
  id: 2,
  name: au(translations).eWayBillUpdate || 'E-Way Bill Update',
})

export const getBookingDeliveryChargesUpdate = (translations) => ({
  id: 3,
  name: au(translations).bookingDeliveryChargesUpdate || 'Booking / Delivery Charges Update',
})

export const getCancelEditTransaction = (translations) => ({
  id: 4,
  name: au(translations).cancelEditTransaction || 'Cancel / Edit Transaction',
})

export const getRollBack = (translations) => ({
  id: 5,
  name: au(translations).rollBack || 'Roll Back',
})

export const getMarkAsLost = (translations) => ({
  id: 6,
  name: au(translations).markAsLost || 'Mark As Lost',
})

export const getConsignmentBookingChargesUpdate = (translations) => ({
  id: 7,
  name: au(translations).consignmentBookingChargesUpdate || 'Consignment / Booking Charges Update',
})

export const getRefundLR = (translations) => ({
  id: 8,
  name: au(translations).refundCancelLr || 'Refund/Cancel LR',
})

export const getTabPopupTabs = (translations, selectedRadio) => {
  const t = au(translations)
  if (selectedRadio === 'showLr') {
    return [t.senderReceiverDetailChangeTab || 'SENDER/RECEIVER DETAIL CHANGE']
  }
  if (selectedRadio === 'adminUpdate') {
    return [
      t.senderReceiverDetailChangeTab || 'SENDER/RECEIVER DETAIL CHANGE',
      t.ewayBillUpdateTab || 'EWAY BILL UPDATE',
      t.bookingDeliveryChargeTab || 'BOOKING/DELIVERY CHARGE',
    ]
  }
  return [
    t.senderReceiverDetailChangeTab || 'SENDER/RECEIVER DETAIL CHANGE',
    t.ewayBillUpdateTab || 'EWAY BILL UPDATE',
    t.consignmentBookingChargeUpdateTab || 'CONSIGNMENT/BOOKING CHARGE UPDATE',
  ]
}

export const getTabPopupHeadTxt = (translations, senderSectContent, selectedRadio) => {
  const t = au(translations)
  if (senderSectContent === 0) return t.senderReceiverDetailsChange || 'Sender Receiver Details Change'
  if (senderSectContent === 1) return t.ewayBillUpdate || 'Eway Bill Update'
  if (selectedRadio === 'modify') return t.consignmentBookingChargeUpdate || 'Consignment/Booking Charge Update'
  return t.bookingDeliveryCharge || 'Booking / Delivery Charge'
}

export const getPriceSection = (translations, companyId) => {
  const t = au(translations)
  return [
    { label: t.totalFreight || 'Total Freight', type: 'text', id: 'freight', width: '9.3%', readOnly: true },
    { label: t.pickupCartage || 'Pickup Cartage', type: 'text', id: 'CCBrkup_pckp', width: '9.3%' },
    { label: t.miscCartage || 'Misc. Cartage', type: 'text', id: 'CCBrkup_cmsn', width: '9.3%' },
    { label: t.dropCartage || 'Drop Cartage', type: 'text', id: 'del_cartage', width: '9.3%' },
    { label: t.hamali || 'Hamali', type: 'text', id: 'hamali', width: '9.3%' },
    {
      label: isStaCompany(companyId) ? getStaOperatorHamaliLabel(false) : t.opHamali || 'Op Hamali',
      type: 'text',
      id: 'op_hamali',
      width: '9.3%',
    },
    { label: t.valuation || 'Valuation', type: 'text', id: 'valuation', width: '9.3%' },
    { label: t.docFee || 'Doc Fee', type: 'text', id: 'doc_fee', width: '9.3%' },
    { label: t.pickupFee || 'Pickup Fee', type: 'text', id: 'pickup_fee', width: '9.3%' },
    { label: t.dropoffFee || 'Dropoff Fee', type: 'text', id: 'dropoff_fee', width: '9.3%' },
    { label: t.gst || 'GST', type: 'text', id: 'gst', width: '9.3%' },
  ]
}

export const getConsignmentPriceSection = (translations, companyId) => {
  const t = au(translations)
  return [
    { label: t.totalFreight || 'Total Freight', type: 'text', id: 'freight', width: '9.3%', readOnly: true },
    { label: t.collCartage || 'Coll. Cartage', type: 'text', id: 'coll_cartage', width: '9.3%' },
    { label: t.dropCartage || 'Drop Cartage', type: 'text', id: 'del_cartage', width: '9.3%' },
    { label: t.hamali || 'Hamali', type: 'text', id: 'hamali', width: '9.3%' },
    {
      label: isStaCompany(companyId) ? getStaOperatorHamaliLabel(false) : t.opHamali || 'Op Hamali',
      type: 'text',
      id: 'op_hamali',
      width: '9.3%',
    },
    { label: t.valuation || 'Valuation', type: 'text', id: 'valuation', width: '9.3%' },
    { label: t.docFee || 'Doc Fee', type: 'text', id: 'doc_fee', width: '9.3%' },
    { label: t.pickupFee || 'Pickup Fee', type: 'text', id: 'pickup_fee', width: '9.3%' },
    { label: t.dropoffFee || 'Dropoff Fee', type: 'text', id: 'dropoff_fee', width: '9.3%' },
    { label: t.gst || 'GST', type: 'text', id: 'gst', width: '9.3%' },
  ]
}

export const getFlaggedConsignmentPriceSection = ({
  translations,
  companyId,
  companySettings = {},
  roleRights = {},
  citywiseBranchList = [],
  ParentCompanyID,
} = {}) => {
  const priceSection = getConsignmentPriceSection(translations, companyId)
  const {
    IsCartage,
    IsDelCartage,
    IsHamali,
    IsOperatorHamali,
    IsInsurance,
    IsDocument,
    IsPickUpAndDropOffChg,
    DisableDocChg,
    RemovePickupcartage,
    RemoveBookingDropcartage,
    RemoveHamali,
    RemoveOpHamali,
    RemoveValuation,
    RemoveDocfee,
    RemovePickupfee,
    RemoveDropofffee,
    IsServiceTax,
    IsHamaliDisable,
    IsOperatorHamaliDisable,
    IsInsuranceDisable,
    IsDocumentDisable,
    PickUpFeeDisable,
    IsDropoffFeeDisable,
  } = companySettings || {}
  const { DisablePickupCartage, DisableBookingDeliveryCartage } = citywiseBranchList?.[0] || {}
  const { AllowHamaliEdit, AllowOperatorHamaliEdit, AllowShowAdditional } = roleRights?.Table1?.[0] || {}
  const isSta = isStaCompany(companyId)

  if (shouldUseBookingPriceFlagsOnModify(companyId)) {
    const flagged = [
      { ...priceSection[0], readOnly: true },
      {
        ...priceSection[1],
        readOnly: !IsCartage || DisablePickupCartage === 1,
        hidden: !!RemovePickupcartage,
      },
      {
        ...priceSection[2],
        readOnly: !IsDelCartage || DisableBookingDeliveryCartage === 1,
        hidden: !!RemoveBookingDropcartage,
      },
      {
        ...priceSection[3],
        readOnly: IsHamaliDisable || !AllowHamaliEdit,
        hidden: !!RemoveHamali,
      },
      {
        ...priceSection[4],
        readOnly: IsOperatorHamaliDisable || !AllowOperatorHamaliEdit,
        hidden: !!RemoveOpHamali,
      },
      {
        ...priceSection[5],
        readOnly: !!IsInsuranceDisable,
        hidden: !!RemoveValuation,
      },
      {
        ...priceSection[6],
        readOnly: IsDocumentDisable || ParentCompanyID === GT_COMPANY_ID,
        hidden: !!RemoveDocfee,
      },
      {
        ...priceSection[7],
        readOnly: !!PickUpFeeDisable,
        hidden: !!RemovePickupfee,
      },
      {
        ...priceSection[8],
        readOnly: !!IsDropoffFeeDisable,
        hidden: !!RemoveDropofffee,
      },
      { ...priceSection[9], readOnly: true, hidden: !IsServiceTax },
    ]
    return flagged.filter((item) => !item.hidden)
  }

  return [
    priceSection[0],
    { ...priceSection[1], readOnly: AllowShowAdditional === 0 || !IsCartage || DisablePickupCartage === 1 },
    { ...priceSection[2], readOnly: AllowShowAdditional === 0 || !IsDelCartage || DisableBookingDeliveryCartage === 1 },
    { ...priceSection[3], readOnly: AllowShowAdditional === 0 || !IsHamali || !AllowHamaliEdit },
    {
      ...priceSection[4],
      readOnly: isSta ? false : AllowShowAdditional === 0 || !IsOperatorHamali || !AllowOperatorHamaliEdit,
    },
    { ...priceSection[5], readOnly: isSta ? false : AllowShowAdditional === 0 || !IsInsurance },
    {
      ...priceSection[6],
      readOnly: isSta ? false : AllowShowAdditional === 0 || !IsDocument || ParentCompanyID === GT_COMPANY_ID || DisableDocChg === 1,
    },
    { ...priceSection[7], readOnly: AllowShowAdditional === 0 || !IsPickUpAndDropOffChg },
    { ...priceSection[8], readOnly: AllowShowAdditional === 0 || !IsPickUpAndDropOffChg },
    { ...priceSection[9], readOnly: true },
  ]
}

export const getDeliveryChargeSection = (translations) => {
  const t = au(translations)
  return [
    { label: t.extraHamali || 'Extra Hamali', type: 'text', value: '', id: 'Extra_Hamali', width: '8%' },
    { label: t.deliveryHamali || 'Delivery Hamali', type: 'text', id: 'Del_Hamali', width: '8%' },
    { label: t.demurage || 'Demurage', type: 'text', id: 'Demurage', width: '8%' },
    { label: t.dropCartage || 'Drop Cartage', type: 'text', id: 'Del_Cartage', width: '8%', value: '' },
    { label: t.deliveryGst || 'Delivery GST', type: 'text', id: 'Delivery_GST', width: '8%', value: '' },
  ]
}

const canEditDeliveryCharge = (allowDelChgChange) =>
  [accessNameV2.LIMITED, accessNameV2.UNLIMITED].includes(Number(allowDelChgChange))

const isDemurrageReadOnly = (allowDemChgChange) => {
  const demChgRight = Number(allowDemChgChange)
  return demChgRight === accessNameV2.NOT_ENABLED || demChgRight === accessNameV2.NO_RIGHTS
}

export const getFlaggedDeliveryChargeSection = ({
  translations,
  companyId,
  companySettings = {},
  roleRights = {},
  citywiseBranchList = [],
  paymentTypeId,
} = {}) => {
  const section = getDeliveryChargeSection(translations)
  if (!shouldUseBookingPriceFlagsOnModify(companyId)) return section

  const { IsExtraHamali, IsDelCartage, DefaultCurrencyID } = companySettings || {}
  const { AllowDelChgChange, AllowDemChgChange } = roleRights?.Table1?.[0] || {}
  const { DisableDeliveryCartage } = citywiseBranchList?.[0] || {}
  const isFoc = Number(paymentTypeId) === 3
  const delChargeEditable = canEditDeliveryCharge(AllowDelChgChange)
  const hideDropCartage = IsDelCartage !== 0
  const dropCartageReadOnly = DisableDeliveryCartage === 1 || !delChargeEditable || IsDelCartage === 0

  return [
    { ...section[0], readOnly: isFoc || !IsExtraHamali },
    { ...section[1], readOnly: isFoc || !delChargeEditable },
    { ...section[2], readOnly: isFoc || isDemurrageReadOnly(AllowDemChgChange) },
    { ...section[3], readOnly: isFoc || dropCartageReadOnly, hidden: hideDropCartage },
    { ...section[4], readOnly: true, hidden: Number(DefaultCurrencyID) === 2 },
  ]
}

